import type { PublicFormCaptchaTokens } from '@client/utils/turnstile/public-form-captcha-tokens';
import { HTTP_HEADER } from '@shared/constants';
import type { Operation } from '@trpc/client';

type CaptchaHeaderOperation = Pick<Operation, 'context' | 'path'>;
type CaptchaTokenLoader = (operation: CaptchaHeaderOperation) => Promise<PublicFormCaptchaTokens>;

export async function buildCaptchaHeaders(
    opList: readonly [CaptchaHeaderOperation, ...CaptchaHeaderOperation[]],
    getCaptchaTokens: CaptchaTokenLoader,
): Promise<Record<string, string>> {
    const captchaOperation = opList.find((operation) => operation.context.captcha === true);
    if (!captchaOperation) return {};

    const { turnstileToken } = await getCaptchaTokens(captchaOperation);
    const headers: Record<string, string> = {};

    if (turnstileToken) {
        headers[HTTP_HEADER.TURNSTILE_TOKEN] = turnstileToken;
    }

    return headers;
}
